import { NgModel } from '@angular/forms';
var UIInputErrorComponent = /** @class */ (function () {
    function UIInputErrorComponent() {
        this.showErrorValidation = false;
    }
    Object.defineProperty(UIInputErrorComponent.prototype, "error", {
        get: function () {
            var _a = this, input = _a.input, name = _a.name, showErrorValidation = _a.showErrorValidation;
            if (showErrorValidation) {
                return showErrorValidation;
            }
            if (input.dirty || input.touched) {
                return input.errors && input.errors[name];
            }
            return showErrorValidation;
        },
        enumerable: true,
        configurable: true
    });
    return UIInputErrorComponent;
}());
export { UIInputErrorComponent };
